// Core 
import { 
  Button,
  Flex, 
  Box,
  Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalBody,
  ModalCloseButton,
  Text, 
} from '@chakra-ui/react';
import { textLang } from 'services/Lang';

// Assets
import matchImage from 'assets/img/match.png';

const MatchModal = ({handle, handleNext, onOpen, isOpen, onClose}) => {
  return (
    	<> 
        <Modal isOpen={isOpen} onClose={onClose}>
          <ModalOverlay />
          <ModalContent className="modal__simple modal__match" 
              maxW={{ base: '100%' }} maxH={{ base: '100%' }} w="100%" h="100%">
                            
              <Box 
                position="relative" 
                h="50%"
                p="40px 20px 24px 20px" 
                bg={`url(${matchImage})`}
                backgroundPosition="center center"
                backgroundSize="cover"
                textAlign="center">
                <Box
                  top="50%"
                  position="absolute"
                  transform="translate(-50%, -50%)"
                  left="50%"
                  >
                  <Text 
                    variant="title-lg" 
                    color="white" 
                    fontSize="24px">
                    
                    {textLang('match_user_match')}
                  </Text>

                  <Button 
                    mt="8px"
                    bg="white !important"
                    color="black"
                    variant="button-lg" 
                    onClick={() => { handle(); onClose(); }} 
                    color="black">{textLang('match_user_go_to_chat')}</Button>

                  <Button 
                    mt="8px"
                    variant="button-md" 
                    onClick={() => { onClose(); handleNext(); }}>{textLang('close')}</Button>
                </Box>
              </Box>

          </ModalContent>
        </Modal> 
      </>
  );
};

export default MatchModal;